/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const productJsonContainer = document.querySelector('[data-product-json]')
if(productJsonContainer) {
  const productJson = JSON.parse(productJsonContainer.innerHTML)
}

function updateVideo(event) {
  const variantMetafields = productJson?.variants_metafields?.[event.detail.variant.id]
  const video = variantMetafields?.details?.video?.split("&")?.[0].replace('http://www.youtube.com/v/', "")
  const videoContainer = document.querySelector('.youtube-video-container')
  if(!video || !videoContainer) return
  const iframe = videoContainer.querySelector('iframe')
  const newUrl = `https://www.youtube.com/embed/${video}`
  if(newUrl === iframe.src) return

  videoContainer.querySelector('iframe').src = newUrl
}

function updateTable(event) {
  const variantId = event.detail.variant.id;
  const previousActiveVariant = document.querySelector('[data-variant-current=true]')

  if(previousActiveVariant) {
    previousActiveVariant.setAttribute('data-variant-current', false)
  }

  const currentVariantElement = document.querySelector('[data-variant-id="' + variantId + '"]')
  if(currentVariantElement) {
    currentVariantElement.setAttribute('data-variant-current', true)
  }
}




document.addEventListener('variant:changed', function(event) {
  updateVideo(event)
  updateTable(event)
});

document.addEventListener("DOMContentLoaded", function() {
  const productList = document.querySelector('.product-list');
  if (!productList) return;

  function updateProductListLayout() {
      const productList = document.querySelector('.product-list');
      if (!productList) return;
      const selectedButton = document.querySelector('.collection__layout-button.is-selected');
      if (selectedButton) {
          const layoutMode = selectedButton.getAttribute('data-layout-mode');
          productList.setAttribute('data-layout', layoutMode);
      }
  }

  function initializeObserver() {
      const buttons = document.querySelectorAll('.collection__layout-button');
      
      const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.classList.contains('is-selected')) {
                  updateProductListLayout();
              }
          });
      });

      buttons.forEach(button => {
          observer.observe(button, { attributes: true });
      });
  }

  // On page load, initialize the product-list layout based on the selected button and start observing
  updateProductListLayout();
  initializeObserver();

  document.addEventListener('theme:loading:end', function() {
      // When the theme finishes loading (like after changing sort order), update the layout and reinitialize the observer
      updateProductListLayout();
      initializeObserver();
  });
});


document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  const toolsInfo = document.getElementById('tools-info');

  if (!toolsInfo || !variant) return;

  // Recuperiamo i metafield delle varianti dal JSON generato dal Liquid
  const productDataEl = document.querySelector('[data-product-json]');
  if (!productDataEl) return;

  const productData = JSON.parse(productDataEl.textContent);
  const variantMetafields = productData.variants_metafields[variant.id];

  if (variantMetafields && variantMetafields.details && variantMetafields.details.n_of_tools) {
    toolsInfo.textContent = `Prezzo riferito a confezione da ${variantMetafields.details.n_of_tools} pz`;
  } else {
    toolsInfo.textContent = '';
  }
});






